'use client';

import { useRef } from 'react';

import { useTranslations } from 'next-intl';

import { RecapAsset } from '@/api/trading/types';
import { Container } from '@/blocks/components/Container';
import { DataGridWrapper } from '@/blocks/components/DataGrid';
import { DeprecatedTabs, DeprecatedTabsOverflowContainer } from '@/blocks/components/DeprecatedTabs';
import { AccentFragment } from '@/blocks/components/HeadingAccentFragment';
import { VStack } from '@/blocks/components/layout';
import { EventBlockNames } from '@/providers/analytics/types';

import { useCfdMarketsTable } from '@/app/[lang]/cfd-trading/(components)/useCfdMarketsTable';

import { CfdAllMarketsSearch } from './CfdAllMarketsSearch';
import styles from './styles.module.scss';
import { CfdAllMarketsTableHeader } from './СfdAllMarketsTableHeader';

export function CfdAllMarketsTable({ initialData }: { initialData: RecapAsset[] | null }) {
  const tr = useTranslations();
  const ref = useRef<HTMLDivElement | null>(null);

  const useMarketsReturn = useCfdMarketsTable({ initialData });

  if (!useMarketsReturn) {
    return null;
  }

  const { tabs, selectedTab, loading, rows, columns, onRowClick, columnsVisibilityModel } = useMarketsReturn;

  return (
    <section data-event-block-name={EventBlockNames.assets_table}>
      <VStack>
        <Container>
          <CfdAllMarketsTableHeader
            title={tr.rich('pages.cfd.all.sections.markets.title', {
              br: (_) => <br />,
              span: (_) => <AccentFragment>{_}</AccentFragment>,
            })}
            subtitle={tr.rich('pages.cfd.all.sections.markets.description')}
          />
        </Container>
        <CfdAllMarketsSearch />
        <div ref={ref}>
          <DeprecatedTabsOverflowContainer className={styles.tabs}>
            <DeprecatedTabs selected={tabs[0].value} values={tabs} navigation />
          </DeprecatedTabsOverflowContainer>
          <Container>
            <DataGridWrapper
              loading={loading}
              columns={columns}
              rows={rows}
              onRowClick={onRowClick}
              columnVisibilityModel={columnsVisibilityModel}
              elementToScrollOnPaginate={ref}
            />
          </Container>
        </div>
      </VStack>
    </section>
  );
}
